import { Box, Button, Flex, Text } from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  cancelSubscription,
  cancelTrial,
  createSubscription,
  downgradePlan,
  forcePayment,
  upgradePlan,
} from "../../services/subscription";
import {
  isSubscriptionExpired,
  performLogout,
  showInfo,
} from "../../utils";
import swal from "sweetalert";
import { getProfile } from "../../services/profile";
import RoundedCheckMarkIcon from "../Svgs/RoundedCheckMarkIcon";
import useStyles from "./style";

const PlanCard = ({
  activeId,
  allPackages,
  packageId,
  title,
  price,
  plan,
  level,
  billing,
  btn,
  stripePlanId,
  duration,
  isUpgradePlan,
}) => {
  const { classes, cx } = useStyles();
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const { activeStaffCount } = useSelector((state) => state.staff);
  const isTrialActive = profile?.user?.isTrialActive;
  console.log("🚀 ~ PlanCard ~ isTrialActive:", isTrialActive)
  const isYearly = profile?.subscription?.subscriptionType === "year";
  const navigate = useNavigate();

  let downgraded = false;
  let [action] = [...(profile?.subscription?.actions || [])]?.slice(-1);
  const conatinsDowngrade = action?.actionType?.includes("downgraded");
  let inPeriod = new Date() <= new Date(action?.updatedDetails?.endedAt);
  let split = action ? action?.actionType?.split(" ")?.slice(0) : [""];

  const [priceId] = split?.slice(-1);
  const downgradedTo = allPackages?.find((v) => v?.stripeId === priceId);

  if (action && conatinsDowngrade && inPeriod) downgraded = true;

  const subscriptionType = duration === "year" ? "year" : "month";
  const currentType = profile?.subscription?.subscriptionType;
  const targetType = duration === "year" ? "year" : "month";
  const isMonthToYearUpgrade = currentType === "month" && targetType === "year";

  const confirmation = (type, cancelData) => {
    if (type === "upgrade") {
      swal({
        title: `Upgrade Plan to ${title}`,
        text: `Plan Duration: ${duration}\nAmount: $ ${price}\n\nNote: Upgrade charges will be applied immediately, and a new subscription plan will take effect instantly.`,
        icon: "info",
        buttons: ["Cancel", "Upgrade Now"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await upgradePlan({
            packageId,
            stripePlan: stripePlanId,
            upgrade: true,
            subscriptionType,
            ...(isMonthToYearUpgrade && { monthToYear: true }),
          });
          if (response) {
            setLoading(false);
            showInfo("Plan upgraded successfully.");
          } else setLoading(false);
        }
      });
    } else if (type === "downgrade") {
      const staffLimit =
        Number(plan?.staff) +
          (plan?.name === "Starter"
            ? 0
            : profile?.user?.additionalStaffCount || 0) || 0;

      if (activeStaffCount > staffLimit) {
        swal({
          title: "Downgrade Not Allowed",
          text: `You currently have more Staff than this downgraded package supports. Please deactivate any non active Staff to allow for this downgrade`,
          icon: "warning",
          buttons: ["Cancel", "OK"],
        });
        return;
      }

      swal({
        title: `Downgrade Plan to ${title}`,
        text: `Plan Duration: ${duration}\nAmount: $ ${price}\n\nNote: This subscription is recurring downgrading a subscription will kick in the following subscription period.`,
        icon: "info",
        buttons: ["Cancel", "Downgrade Now"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await downgradePlan({
            packageId,
            stripePlan: stripePlanId,
            upgrade: false,
            subscriptionType,
          });
          if (response) {
            showInfo(
              "Plan downgraded successfully. \nPayment due at the end of the active subscription period.",
            );
            setLoading(false);
          } else setLoading(false);
        }
      });
    } else if (type === "trial") {
      swal({
        title: `You are currently on a free trial`,
        text: `Would you like to subscribe to the ${title} plan now?`,
        icon: "info",
        buttons: ["Cancel", "Subscribe Now"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let obj = {
            packageId: packageId,
            stripePlanId: stripePlanId,
            email: profile?.user?.email,
            userId: profile?.user?.id,
            businessId: profile?.business?.id,
            stripeCustomerId: profile?.subscription?.stripeCustomerId,
            forcefully: true,
            subscriptionType,
          };
          let response = await createSubscription(obj, null, "automatic");
          if (response) {
            getProfile();
            showInfo("Plan subscribed successfully.");
            setLoading(false);
          } else setLoading(false);
        }
      });
    } else if (type === "cancel-trial") {
      swal({
        title: `Cancel Trial Subscription Plan`,
        text: `Are you sure you want to cancel this trial subscription?`,
        icon: "info",
        dangerMode: true,
        buttons: ["Cancel", "Cancel Trial"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await cancelTrial(cancelData);
          if (response?.status === 200) {
            setLoading(false);
            performLogout("/");
          } else setLoading(false);
        }
      });
    } else {
      swal({
        title: `Cancel Subscription "${title}" Plan`,
        text: `Are you sure you want to cancel this subscription?`,
        icon: "info",
        dangerMode: true,
        buttons: ["Cancel", "Cancel Subscription"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await cancelSubscription(cancelData);
          if (response?.status === 200) {
            setLoading(false);
            performLogout("/");
          } else setLoading(false);
        }
      });
    }
  };

  const onClick = async () => {
    if (isTrialActive) {
      confirmation("trial");
      return;
    }
    if (Number(activeId?.cost) === 0) {
      navigate("/payInfo", {
        state: {
          planId: packageId,
          stripePlan: stripePlanId,
          plan,
        },
      });
    } else {
      if (
        Number(level) < Number(activeId?.level) &&
        activeId?.duration === "month" &&
        duration === "year"
      ) {
        confirmation("downgrade");
      } else if (Number(price) > Number(activeId?.cost)) {
        confirmation("upgrade");
      } else {
        confirmation("downgrade");
      }
    }
  };

  const cancelSub = async () => {
    if (isTrialActive) {
      confirmation("cancel-trial", {
        _id: profile?.subscription?.id,
        stripeSubscriptionId: profile?.subscription?.stripeSubscriptionId,
      });
    } else {
      confirmation("cancel-subscription", {
        _id: profile?.subscription?.id,
        stripeSubscriptionId: profile?.subscription?.stripeSubscriptionId,
      });
    }
  };

  const reNewSubscription = async () => {
    await forcePayment();
  };

  const isDowngrade = Number(price) < Number(activeId?.cost);
  const disableMonthlyForYearlyUser =
    isYearly && (duration === "month" || isDowngrade);

  return (
    <Box
      className={
        activeId?.id == packageId
          ? cx(classes.pkgCard, classes.activePkgCard)
          : classes.pkgCard
      }
    >
      <Box>
        <Flex className={classes.pkgNameRow}>
          <p>
            {title}
            {title === "Bronze" && (
              <img src="/assets/images/bronze-medal.png" />
            )}
            {title === "Silver" && (
              <img src="/assets/images/silver-medal.png" />
            )}
            {title === "Gold" && <img src="/assets/images/gold-medal.png" />}
          </p>
          {isTrialActive && (activeId?.id == packageId ? <p>Trial</p> : null)}
        </Flex>
        <p className={classes.pkgPrice}>
          ${price}
          <span>/{duration}</span>
        </p>
      </Box>
      <Box
        className={cx(
          classes.pkgBottomContent,
          isUpgradePlan && classes.upgradePlanBgColor,
        )}
      >
        <Box
          className={cx(
            classes.desAndDetailsBox,
            isUpgradePlan && classes.upgradePlanList,
          )}
        >
          <Flex className={classes.listParent}>
            <p>
              <RoundedCheckMarkIcon color={isUpgradePlan && "#9E77ED"} />
              {plan?.staff} Staff Members
            </p>
          </Flex>
          {activeId?.id == packageId ? (
            <Text>
              {price != 0 && (
                <Text className={classes.billing}>
                  {isTrialActive ? "Trial Cycle :" : "Billing Cycle : "}
                  <span className={classes.cycle}>{billing}</span>
                </Text>
              )}
              {downgraded ? (
                <div className={classes.cycle} style={{ color: "#979797a0" }}>
                  {`You have downgraded this Plan to ${downgradedTo?.name}. Changes will reflect by the end of this period.`}
                </div>
              ) : null}
            </Text>
          ) : null}
        </Box>
        {activeId?.id != packageId && (
          <Button
            loading={loading}
            onClick={onClick}
            className={cx(classes.selectBtn, isUpgradePlan && classes.upgradeBtn)}
            loaderProps={{ color: "black" }}
            disabled={disableMonthlyForYearlyUser}
          >
            {isTrialActive ? "Subscribe Plan" : btn}
          </Button>
        )}
        {activeId?.id == packageId && (
          <Button className={classes.cancelSubBtn} disabled>
            Currently Active
          </Button>
        )}
        {activeId?.id == packageId && Number(activeId?.cost) !== 0 && (
          <Button
            loading={loading}
            onClick={cancelSub}
            className={classes.cancelSubBtn}
          >
            {isTrialActive ? "Cancel Trial" : "Cancel Subscription"}
          </Button>
        )}
        {activeId?.id == packageId && isSubscriptionExpired() && price != 0 && (
          <Button
            loading={loading}
            onClick={reNewSubscription}
            className={classes.selectBtn}
          >
            Renew Subscription
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PlanCard;
